module.exports = __webpack_public_path__ + "static/media/dead.00cffd70.png";